/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

let curCat = null
let curSchool = 'all'
let curFileSearch = ''

$('body').click(function (event) {
  const $docSelector = $('.doc-school-selector')

  if (event.target.className === 'doc-school-selector-label' || $(event.target).parents('.doc-school-selector-label').length) {
    $docSelector.toggleClass('open')
    return
  }
  $docSelector.removeClass('open')
})

function initDocsSchoolSelector () {
  $('.doc-school-selector-school a').each(function () {
    const $el = $(this)
    $el.click(function (event) {
      event.preventDefault()
      const slug = $el.data('slug')
      $('.doc-school-selector-school.active').removeClass('active')
      $el.parent().addClass('active')
      $('.doc-school-selector-label span').text($el.text())
      curSchool = slug
      applyDocsFilter()
    })
  })
  $('.files-categories .doc-search-input input').keyup(function () {
    curFileSearch = $(this).val().replace(/(^\s+|\s+$)/g, '').toLowerCase()
    applyDocsFilter()
  })
}

function filterDocs (el, cat) {
  curCat = cat ? cat.toLowerCase() : null

  $('.file-category.active').removeClass('active')
  $(el).addClass('active')

  applyDocsFilter()
}

function applyDocsFilter () {
  $('#district-files .media-tile').each(function () {
    const $tile = $(this)
    const school = $tile.data('school').split(',')
    let vis = (!curCat || $tile.find('.media-tile-subtitle').first().text().toLowerCase() === curCat)
      && (curSchool === 'all' || !school.length || school.indexOf(curSchool) >= 0)

    if (vis && curFileSearch.length && $tile.text().toLowerCase().indexOf(curFileSearch) < 0) {
      vis = false
    }

    if (vis) {
      $tile.stop().fadeIn('fast')
    } else {
      $tile.stop().fadeOut('fast')
    }
  })
}

function appendPreviewLogic () {
  $('.media-tile, .docs-meta-btn.view').click(function (event) {
    if ($(this).data('locked')) {
      return
    }

    event.preventDefault()

    const path = {
      source: $(this).attr('href'),
      preview: $(this).attr('href'),
      id: $(this).data('document'),
      roleDescription: $(this).data('role-description')
    }

    const ext = path.source.match(/(?:\.([^.]+))?$/)[1]

    if (hasExtMatch(ext, ['xls', 'xlsx'])) {
      displayFilePreview('excel', path, this)
      return
    }
    if (hasExtMatch(ext, ['doc', 'docx'])) {
      displayFilePreview('word', path, this)
      return
    }
    if (hasExtMatch(ext, ['ppt', 'pptx'])) {
      displayFilePreview('powerpoint', path, this)
      return
    }
    if (hasExtMatch(ext, ['pdf'])) {
      displayFilePreview('pdf', path, this)
      return
    }
    if (hasExtMatch(ext, ['jpg', 'jpeg', 'png', 'bpm', 'gif'])) {
      displayFilePreview('bitmap', path, this)
      return
    }

    window.open(path.source)
  })
}

function hasExtMatch (ext, extArray) {
  for (let i = 0; i < extArray.length; i++) {
    if (extArray[i].toLowerCase() === ext.toLowerCase()) {
      return true
    }
  }
  return false
}

function displayFilePreview (type, path, el) {
  const $el = $(el)
  try {
    window.history.replaceState(path, 'Document bekijken', '/docs/' + path.id)
  } catch (e) {}

  $('body').append('<div class="preview"><a class="preview-close"><svg width="32px" height="31px" viewBox="0 0 32 31" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.400000006"><g transform="translate(-1245.000000, -53.000000)" fill="#FFFFFF"><g transform="translate(1245.000000, 53.000000)"><rect transform="translate(16.000000, 15.500000) rotate(-45.000000) translate(-16.000000, -15.500000) " x="-3" y="13" width="38" height="5"/><rect transform="translate(16.000000, 15.500000) rotate(45.000000) translate(-16.000000, -15.500000) " x="-3" y="13" width="38" height="5"/></g> </g></g></svg></a><div class="preview-actions"></div><div class="container"></div></div>')

  const $container = $('.preview > .container')
  $container.append('<div class="docs-meta"><a class="docs-meta-btn download" title="Download" target="_blank" href="' + repairURL(path.source) + '"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fill-rule="nonzero"><path d="M14.163 10.218c0-.435.345-.786.77-.786.426 0 .77.35.77.786v3.143c0 1.304-1.034 2.36-2.31 2.36H2.607c-1.276 0-2.31-1.056-2.31-2.36V10.22c0-.435.344-.786.77-.786.425 0 .77.35.77.786v3.143c0 .435.345.787.77.787h10.786c.425 0 .77-.352.77-.786V10.22z"/><path d="M11.307 5.732a.76.76 0 0 1 1.09 0c.3.307.3.805 0 1.11l-3.852 3.93a.76.76 0 0 1-1.09 0l-3.852-3.93a.797.797 0 0 1 0-1.11.76.76 0 0 1 1.09 0L8 9.106l3.307-3.374z"/><path d="M8.77 10.218a.778.778 0 0 1-.77.786.778.778 0 0 1-.77-.786V.786C7.23.352 7.575 0 8 0c.425 0 .77.352.77.786v9.432z"/></g></svg></a><div class="docs-meta-subtitle">' + $el.data('category') + '</div><div class="docs-meta-title">' + $el.data('title') + '</div><div class="docs-meta-item"><span>Grootte:</span>' + $el.data('size') + '</div><span class="media-tile-labels">' + (!window.config.singleMode ? '<span class="media-tile-label" style="background-color: ' + $el.data('school-color') + ';">' + $el.data('school-title') + '</span>' : '') + '</span></div>')

  if (path.roleDescription) {
    $container.append(`
      <div class="auth-current">
        <div>
          <span class="icon-white icon-lock"></span>
          ${path.roleDescription}
        </div>
        <a href="/docs/?hoy=logout" onclick="$('.preview').remove();">Uitloggen</a>
      </div>
    `)
  }

  if (type === 'pdf') {
    $container.append('<div class="inner"><iframe src="https://lowcdn.com/2x/_/pdfjs/web/viewer.html?file=' + repairURL(path.preview) + '&embedded=true" frameborder="0"></iframe></div>')
  } else if (type === 'excel' || type === 'powerpoint' || type === 'word') {
    $container.append('<div class="inner"><iframe src="https://view.officeapps.live.com/op/embed.aspx?src=' + repairURL(path.preview) + '" frameborder="0"></iframe></div>')
  } else if (type === 'bitmap') {
    $container.append('<div class="inner"><img src="' + path.preview + '"/></div>')
  }

  $('.preview').click(function (event) {
    if (event.target.className === 'preview') {
      $('.preview').fadeOut(function () {$(this).remove()})
      window.history.replaceState({}, 'Documenten', '/docs')
    }
  })

  $('.preview-close').click(function () {
    $('.preview').fadeOut(function () {$(this).remove()})
    window.history.replaceState({}, 'Documenten', '/docs')
  })

  $('.preview-download').click(function () {
    window.open(path.source, '_blank')
  })
}

function repairURL (url) {
  if (url.substring(0, 2) === '//') {
    return 'https:' + url
  }
  return url
}

$(document).on('pjax:end', appendPreviewLogic)
appendPreviewLogic()

$(document).on('pjax:end', initDocsSchoolSelector)
initDocsSchoolSelector()

if ($('body').hasClass('district-files')) {
  var docCategory = window.location.hash.substring(1).toLowerCase()
  if (docCategory.length) {
    $('#cat-' + docCategory).click()
  }
}
